module.exports = __webpack_public_path__ + "img/game_main_pc_232_off.11b48b50.png";